import ProductMiniCard from './ProductMiniCard';

export default ProductMiniCard;
